/* Copyright (c) 2020-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetCloudAccountQuery } from "~/generated/graphql";

type Props = {
  accountId: string;
};

export function useGetCloudAccount({ accountId }: Props) {
  const { data, loading, error, refetch } = useGetCloudAccountQuery({
    variables: { cloudAccountId: accountId },
  });

  return { cloudAccount: data?.cloudAccount, loading, error, refetch } as const;
}
